import styled, { keyframes, css } from "styled-components";
import { colors } from "../../../lib/colors";
import { tabletLargeText } from "../../../media_queries/TabletMediaQueries";

const movingBar = keyframes`
    0%{
        width: 0;
    }

    100%{
        width: 87px;
    }
`;

const progressUp = keyframes`
    0%{
        top: 0;
    opacity: 100%
}
100%{
    top: -40px;
    opacity: 0%;
}
`;

export const ProgressBarContainer = styled.div<{ isVisible: any }>`
  position: relative;
  animation: ${({ isVisible }) =>
    isVisible &&
    css`
      ${progressUp} 1.2s forwards
    `};
  animation-delay: 8s;
`;

export const ProgressBarHeader = styled.h1`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  color: ${colors.lightGrey};
  ${tabletLargeText}
  @media only screen and (min-width: 768px) {
    font-size: 24px;
  }
`;

export const ProgressBarBar = styled.div`
  margin-top: 7px;
  width: 87px;
  border-radius: 100px;
  height: 4px;
  margin-left: auto;
  margin-right: auto;
  background-color: ${colors.progressBarBackground};
  position: relative;
  @media only screen and (min-width: 768px) {
    height: 6px;
  }
`;

export const ProgressBarMoving = styled.div<{ elapsed: any }>`
  border-radius: 100px;
  height: 4px;
  background-image: ${colors.blueGradient};
  animation: ${({ elapsed }) =>
    elapsed &&
    css`
      ${movingBar} 8s
    `};
  z-index: 2000;
  animation-timing-function: linear;
  @media only screen and (min-width: 768px) {
    height: 6px;
  }
`;
